import React, { useEffect, useState } from 'react';
import * as  Yup from 'yup';
import { Aadhaar_Msg, AADHAR_VALIDATION, ERROR_MSG, handleInputToUppercase, handleKeyAlphaNumeric, handleKeyPressNumeric, Mobile_Msg, MOBILE_VALIDATION } from '../CommonUtilities/Validations/RegularExpAndVar';
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import { CommonAxiosGet, CommonAxiosPost } from '../CommonUtilities/CommonAxios/CommonAxios';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { config } from '../CommonUtilities/CommonUrl/CommonUrls';
import { IoIosArrowDown } from 'react-icons/io';
import { validateVerhoeff } from '../CommonUtilities/CommonFunctions/ValidAadhaarFunction';
import { CommonPageHeading } from '../CommonUtilities/CommonHeading/CommonPageHeading';
import { CommonReactTable } from '../CommonUtilities/CommonTable/CommonReactTable';
import { FaHandPointRight, FaRegHandPointRight } from 'react-icons/fa6';
import { BiSolidHandRight } from 'react-icons/bi';
import { useSelector } from 'react-redux';
export default function CandidateOldTetDetails() {
    const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);

    const [showData, setData] = useState(null); // null = not yet requested
    const [showD1, setD1] = useState();
    const [showErrsg, setErrMsg] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const columns = [
        { Header: "S.NO", accessor: (row, index) => index + 1 },
        { Header: "HallTicket No", accessor: "ht_no" },
        { Header: "Subject", accessor: "tet_post_name" },
        { Header: "Year Of Pass", accessor: "yop" },
        { Header: "Score", accessor: "score" },
    ];  
    const Formik = useFormik({
        initialValues: {},
        onSubmit: () => {
            setD1(0);
            setIsLoading(true);
            setErrMsg("");
            setData(null);

            let url = config.url.CONTEXT_READ_URL + "tet-result-uid";
            CommonAxiosGet(url).then((res) => {
                if (res?.data?.status === true) {
                    setData(res?.data?.data);
                    setErrMsg("");
                } else {
                    setData([]);
                    setErrMsg(res?.data?.sdesc);
                }
            })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    });
    return (
        <React.Fragment>
            <FormikProvider value={Formik}>
                <CommonPageHeading heading='Previous TET Details' />
                <Form className="form-section mb-4" onSubmit={Formik.handleSubmit} onChange={Formik.handleChange}>
                    <div className='mt-5 px-2'>
                        <Row className="row px-3">
                            <Col xxl={6} xl={6} lg={6} md={8} sm={12} xs={12} className="mb-3 d-flex align-items-center">
                                <span className="me-2 d-flex align-items-center" style={{ fontWeight: "500" }}>
                                    Click here to get data with Aadhar No &nbsp;
                                    <BiSolidHandRight className="me-2" />
                                </span>
                                <Button type="submit" className="btn btn-primary btn-md">
                                    Get Data
                                </Button>
                            </Col>
                        </Row>
                    </div>

                    {showD1 === 0 && (
                        <>
                            {isLoading && (
                                <div className="text-center mt-4">
                                    Loading, please wait...
                                </div>
                            )}

                            {!isLoading && showData !== null && showData.length > 0 && (
                                <>
                                    <div className="table-responsive">
                                        <table className="table table-bordered mb-3" style={{ background: "beige" }} role="presentation">
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: '10%' }}>Candidate ID :</td>
                                                    <td style={{ width: '15%' }}><b>{loginreducer?.username}</b></td>

                                                    <td style={{ width: '10%' }}>Aadhar No :</td>
                                                    <td style={{ width: '10%' }}><b>{loginreducer?.aadhaar_no}</b></td>

                                                    <td style={{ width: '15%' }}>Name :</td>
                                                    <td style={{ width: '40%' }}><b>{loginreducer?.applicant_name}</b></td>
                                                </tr>
                                                <tr>
                                                    <td style={{ width: '10%' }}>Gender :</td>
                                                    <td style={{ width: '15%' }}><b>{loginreducer?.gender}</b></td>

                                                    <td style={{ width: '10%' }}>Mobile :</td>
                                                    <td style={{ width: '10%' }}><b>{loginreducer?.mobile_no}</b></td>

                                                    <td style={{ width: '15%' }}>Father Name :</td>
                                                    <td style={{ width: '40%' }}><b>{loginreducer?.father_name}</b></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="table-responsive">
                                        <CommonReactTable
                                            tableid='selected-id'
                                            pagination="false"
                                            data={showData}
                                            columns={columns}
                                            serachAlign="left"
                                            isBack={false}
                                            headerName={<>Previous TET Details</>}
                                            headColumCount={5}
                                            search="true"
                                            showFooter="false"
                                            filename="Details"
                                            paginationCount="All"
                                            printFalg="false"
                                        />
                                    </div>
                                </>
                            )}
                            {!isLoading && showData !== null && showData.length === 0 && (
                                <h3 className="text-error mt-4 border p-3 fs-6 w-100">
                                    <strong>Dear {loginreducer?.applicant_name},</strong>
                                    <pre />
                                    {showErrsg} With Aadhar No &nbsp;
                                    <span>
                                        <a
                                            href="/PreviousTetResults"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="badge badge-success forgot fw-bold"
                                            style={{ background: "#2aa89aff", cursor: "pointer", textDecoration: "none" }}
                                        > Click Here
                                        </a>
                                    </span>{" "}
                                    to find details with Mobile No / TET HallTicket No
                                </h3>
                            )}
                        </>
                    )}
                </Form>
            </FormikProvider>
        </React.Fragment>
    );
}

